import { View } from 'react-native'
import { styled } from '~/core/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      flexDirection: 'column',
      gap: theme.spacingStackHalfpulse,
      backgroundColor: 'transparent',
    },
  }
})
